var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upBtn-style"},[_c('div',{staticClass:"upBtn",on:{"click":_vm.scrollToTop}},[_c('img',{staticStyle:{"width":"24px","margin-left":"8px"},attrs:{"src":require("../../../../assets/hw-s111.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }